import React from 'react';
import Layout from "../../components/layout/Layout";
import AdminProductList from '../../components/products/AdminProductList';

const AdminProductsPage = () => {
    return (
        <Layout>
            <main className="admin-background">
                <AdminProductList />
            </main>
        </Layout>
    );
};

export default AdminProductsPage;